import React, { useEffect, useRef, useState } from 'react'

export const LazyAvatar = ({ src, alt, className, placeholder, ...props }) => {
    const [flipping, setFlipping] = useState(false)
    const [currentSrc, setCurrentSrc] = useState(placeholder)
    const timeoutRef = useRef(null)

    useEffect(() => {
        if (src === currentSrc) return

        let isCancelled = false
        const img = new Image()
        img.src = src
        img.onload = () => {
            if (isCancelled) return
            setFlipping(true)
            // After half the animation (0.3s), swap the src
            timeoutRef.current = setTimeout(() => {
                setCurrentSrc(src)
            }, 300)
        }

        return () => {
            isCancelled = true
            clearTimeout(timeoutRef.current)
        }
    }, [src, currentSrc])

    return (
        <div
            className={`rounded-circle d-flex align-items-center justify-content-center logo-circle${flipping ? ' flipping' : ''}`}
            onAnimationEnd={() => setFlipping(false)}
        >
            <img src={currentSrc} alt={alt || 'Image name'} className={`logo-image ${className || ''}`} />
        </div>
    )
}
